export default "__VITE_ASSET__Dm5ady2s__"